import React from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';

import { fetchAll as fetchAllSprint, update as updateSprintSub } from '../../subscriptions/sprint/actions';
import { fetchAll as fetchAllBypassed, update as updateBypassedSub } from '../../subscriptions/bypassed/actions';
import { fetchAll as fetchAllQuick, update as updateQuickSub } from '../../subscriptions/quick/actions';
import { getUser, getAllQuickSubscriptions, getAllBypassedSubscriptions, getAllSprintSubscriptions } from 'reducers';
import Box from 'common/Box';
import toggle_on from '../toggle/toggle_on.svg';
import toggle_off from '../toggle/toggle_off.svg';
import { formatMdn, getCarrier } from '../../helpers/subs';

import styles from './index.module.css';

class SmsNotifications extends React.Component {
  componentDidMount() {
    this.fetchSubs();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.userId !== this.props.userId) {
      this.fetchSubs();
    }
  }

  fetchSubs = () => {
    const { fetchAllSprint, fetchAllBypassed, fetchAllQuick, userId } = this.props;
    if (userId) {
      fetchAllSprint(userId);
      fetchAllBypassed(userId);
      fetchAllQuick(userId);
    }
  }

  handleToggleSubNotification = sub => {
    const { updateSprintSub, updateBypassedSub, updateQuickSub } = this.props;
    const carrier = getCarrier(sub);
    const carrierToApi = {
      sprint: updateSprintSub,
      bypassed: updateBypassedSub,
      quick: updateQuickSub,
    }

    const apiCall = carrierToApi[carrier];
    apiCall(sub.id, { sms_notifications: !sub.sms_notifications });
  }

  
  render() {
    const { sprintSubs, bypassedSubs, quickSubs } = this.props;
    const allSubs = [...sprintSubs, ...bypassedSubs, ...quickSubs];

    if (allSubs.length === 0) {
      return null;
    }

    return (
      <div className={styles.wrapper}>
        <h2 className={styles.title}>SMS Notifications</h2>
        <Box>
          <p className={styles.text}>
            By disabling, you might miss important texts about your account or data usage. You'll still receive email notifications.
          </p>
          <div className={styles.line}></div>
          <ul className={styles.list}>
            {allSubs.map(sub => (
              <li key={sub.id} className={styles.sub}>
                <div className={styles.subInfo}><span><b>{sub.first_name} {sub.last_name}</b></span> <span>{formatMdn(sub.mdn)}</span></div>
                <div className={styles.toggleWrapper}>
                  <span className={styles.toggleStatus}>{sub.sms_notifications ? 'ON' : 'OFF'}</span>
                  <span
                    className={cn(styles.toggle, sub.sms_notifications ? styles.on : styles.off)}
                    onClick={() => this.handleToggleSubNotification(sub)}
                  >
                    {sub.sms_notifications ?
                      <img src={toggle_on} alt="" />
                      :
                      <img src={toggle_off} alt="" />
                    }
                  </span>
                </div>
              </li>
            ))}
          </ul>
        </Box>
      </div>
    );
  }
}        

const mapStateToProps = (state) => ({
  userId: getUser(state) && getUser(state).id,
  sprintSubs: getAllSprintSubscriptions(state),
  bypassedSubs: getAllBypassedSubscriptions(state),
  quickSubs: getAllQuickSubscriptions(state),
});

const mapDispatchToProps = {
  fetchAllSprint,
  fetchAllBypassed,
  fetchAllQuick,
  updateSprintSub,
  updateBypassedSub,
  updateQuickSub,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SmsNotifications);
